export default __webpack_public_path__ + "static/9-ways-to-survive-a-european-winter-b87bb1515effb338906badc172e6b47b.jpg";